import React from 'react'

const IncomeEnhance = () => {
  return (
    <div>IncomeEnhance</div>
  )
}

export default IncomeEnhance